import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { api } from "../api";
import { useStore } from "../store";

const GOOGLE_READY = !!process.env.REACT_APP_GOOGLE_CLIENT_ID;

const HERO_IMG = "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

export default function Welcome() {
  const navigate = useNavigate();
  const { loginCustomer, markWelcomed, welcomed } = useStore();

  // Don't auto-redirect: this page doubles as the registration screen (/benvenuto)

  const afterAuth = (user, token) => {
    loginCustomer(user, token);
    markWelcomed();
    navigate("/", { replace: true });
  };

  const onGoogleSuccess = async (credentialResponse) => {
    try {
      const { data } = await api.post("/auth/google", { id_token: credentialResponse.credential });
      afterAuth(data.user, data.token);
    } catch {
      alert("Accesso con Google non riuscito. Riprova.");
    }
  };

  const onAppleLogin = async () => {
    if (!window.AppleID || !process.env.REACT_APP_APPLE_CLIENT_ID) {
      alert("Accesso con Apple non ancora configurato.");
      return;
    }
    try {
      window.AppleID.auth.init({
        clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
        scope: "name email",
        redirectURI: window.location.origin,
        usePopup: true,
      });
      const data = await window.AppleID.auth.signIn();
      const { data: session } = await api.post("/auth/apple", {
        id_token: data.authorization.id_token,
        user: data.user || null,
      });
      afterAuth(session.user, session.token);
    } catch {
      alert("Accesso con Apple non riuscito. Riprova.");
    }
  };

  return (
    <div className="relative min-h-screen flex flex-col" data-testid="welcome-page">
      <img src={HERO_IMG} alt="Dorae" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/45" />
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-8 text-center">
        <img src="/brand/logo-content.png" alt="Dorae" className="h-20 object-contain bg-white/95 px-6 py-3 rounded-sm" data-testid="welcome-logo" />
        <h1 className="mt-8 font-sans font-medium text-white text-2xl tracking-wide-spaced uppercase" data-testid="welcome-title">
          Benvenuta in Dorae
        </h1>
        <p className="mt-3 text-white/85 text-sm tracking-wide max-w-xs">Accedi per salvare i tuoi ordini e i tuoi dati</p>

        <div className="mt-10 w-full max-w-xs space-y-3">
          {GOOGLE_READY ? (
            <div className="bg-white flex justify-center" data-testid="google-login-wrapper">
              <GoogleLogin onSuccess={onGoogleSuccess} onError={() => alert("Accesso con Google non riuscito")} text="continue_with" locale="it" />
            </div>
          ) : (
            <button
              type="button"
              data-testid="google-login-placeholder"
              onClick={() => alert("Accesso con Google non ancora configurato. Usa Salta per continuare.")}
              className="w-full flex items-center justify-center gap-2 bg-white text-[#2C2C2C] py-3 text-[13px] font-semibold tracking-wide uppercase"
            >
              Accedi con Google
            </button>
          )}
          <button
            type="button"
            data-testid="apple-login-button"
            onClick={onAppleLogin}
            className="w-full flex items-center justify-center gap-2 bg-black text-white py-3 text-[13px] font-semibold tracking-wide uppercase"
          >
            <svg viewBox="0 0 384 512" className="w-4 h-4 fill-current"><path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/></svg>
            Accedi con Apple
          </button>
          <button
            type="button"
            data-testid="skip-login-button"
            onClick={() => { markWelcomed(); navigate("/", { replace: true }); }}
            className="w-full py-3 text-[12px] font-semibold tracking-wide-spaced uppercase text-white/90 underline underline-offset-4"
          >
            {welcomed ? "Torna allo shop" : "Salta"}
          </button>
        </div>
      </div>
    </div>
  );
}
